module.exports = __webpack_public_path__ + "img/banner-logo.6e1ae478.png";